import React from 'react';
import {WithTranslationProps} from 'react-i18next';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';

interface CancelledPremierOnProps extends WithTranslationProps {
  item: {
    cancelledPremierOn: string | null;
  };
}

export const CancelledPremierOn: React.FC<CancelledPremierOnProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = null,
}) => {
  const cancelledPremierOn = get(item, 'cancelledPremierOn', {});
  return tt(
    'cancelledPremierOn',
    generateComponentCallback({
      component: (
        <Text
          testID={Reports.reportCancelledPremierOn}
          allowFontScaling
          maxFontSizeMultiplier={2}>
          Cancelled{' '}
          {getDateUtilDefaultInstance().formatDate(
            cancelledPremierOn,
            'MMMM d, yyyy',
          )}
        </Text>
      ),
    }),
  );
};

export default withTranslation('report.record.cancelledPremierOn')(
  CancelledPremierOn,
);
